export default "__VITE_ASSET__8a42c007__"